import React, { useState, useEffect, useRef } from 'react';
import useSound from 'use-sound';
import flapSound from './splitflap.mp3';
import FlapStack from './FlapStack';

const Text = ({ words, isVolumeOn, setIsVolumeOn }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTextVisible, setIsTextVisible] = useState(false);
  const flapStates = useRef(new Array(words[0].length).fill(false));
  const wordCompleted = useRef(false); // Using ref instead of state
  const [play, { stop }] = useSound(flapSound, { soundEnabled: isVolumeOn });
  const maxLength = words.reduce((max, word) => Math.max(max, word.length), 0);

  useEffect(() => {
    flapStates.current = new Array(words[currentIndex].length).fill(false);
    wordCompleted.current = false; // Reset for new word

    if (isTextVisible && isVolumeOn) {
      play();
    }

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 7000);

    return () => {
      clearInterval(timer);
      stop();
    };
  }, [currentIndex, isTextVisible, isVolumeOn, play, stop]);

  const handleTargetReached = (index, reached) => {
    flapStates.current[index] = reached;
    if (!wordCompleted.current && flapStates.current.every(state => state)) {
      wordCompleted.current = true;
      console.log("Word complete!")
      setTimeout(() => {
        stop();
      }, 250);
    }
  };

  const handleButtonClick = () => {
    setIsTextVisible(true);
    setIsVolumeOn(true);
  };

  const currentWord = isTextVisible ? words[currentIndex] : '';
  const totalPadding = maxLength - currentWord.length;
  const paddingStart = Math.floor(totalPadding / 2);
  const paddedWord = currentWord.padStart(paddingStart + currentWord.length, ' ').padEnd(maxLength, ' ');

  return (
    <div className="flap-display">
      {!isTextVisible && <a href="#" onClick={handleButtonClick} style={{ color: 'white', textDecoration: 'none' }}>ENTER</a>}
      {isTextVisible && paddedWord.split('').map((char, index) => (
        <FlapStack 
          key={`${currentIndex}-${index}`} 
          targetChar={char} 
          timing={50} 
          onTargetReached={() => handleTargetReached(index, true)}
          index={index}
        />
      ))}
    </div>
  );
};

export default Text;
